import { render } from "./VersionHistoryPanel.vue?vue&type=template&id=882c03d6&scoped=true"
import script from "./VersionHistoryPanel.vue?vue&type=script&lang=js"
export * from "./VersionHistoryPanel.vue?vue&type=script&lang=js"

import "./VersionHistoryPanel.vue?vue&type=style&index=0&id=882c03d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-882c03d6"]])

export default __exports__